var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReplied = function SvgReplied(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 187",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 287",
    d: "M884 112.668a.468.468 0 0 1-.411-.245l-.013-.023a7.973 7.973 0 0 0-6.97-4.107h-.887v2.657a.468.468 0 0 1-.795.335l-5.312-5.155a.467.467 0 0 1 0-.672l5.312-5.157a.469.469 0 0 1 .795.337v2.657a8.918 8.918 0 0 1 8.75 8.905.472.472 0 0 1-.353.455.5.5 0 0 1-.116.013zm-8.75-5.312h1.35a8.914 8.914 0 0 1 6.727 3.068 7.984 7.984 0 0 0-7.77-6.194h-.312a.469.469 0 0 1-.469-.469v-2.016l-4.171 4.047 4.171 4.048v-2.016a.469.469 0 0 1 .469-.469z",
    transform: "translate(-868.968 -98.418)",
    style: {
      fill: "#00a358"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReplied, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/replied.65212a6f.svg";
export { ForwardRef as ReactComponent };